"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
const common_1 = require("@angular/common");
const core_1 = require("@angular/core");
const forms_1 = require("@angular/forms");
const idm_ng_controls_1 = require("@synisys/idm-ng-controls");
const idm_dataset_service_client_js_1 = require("@synisys/idm-dataset-service-client-js");
const idm_export_client_js_1 = require("@synisys/idm-export-client-js");
const idm_frontend_shared_1 = require("@synisys/idm-frontend-shared");
const idm_report_export_service_client_js_1 = require("@synisys/idm-report-export-service-client-js");
const idm_reporting_service_client_js_1 = require("@synisys/idm-reporting-service-client-js");
const color_palette_service_1 = require("../chart/shared/service/color-palette.service");
const material_module_1 = require("../../material.module");
const reporting_controls_module_1 = require("../../controls/reporting-controls.module");
const reporting_filter_module_1 = require("../../controls/reporting-filter/reporting-filter.module");
const idm_page_service_client_js_1 = require("@synisys/idm-page-service-client-js");
const sis_reporting_chip_group_component_1 = require("./component/sis-reporting-chip-group.component");
const idm_currency_rate_frontend_1 = require("@synisys/idm-currency-rate-frontend");
const ng2_dragula_1 = require("ng2-dragula");
/**
 * Created by aghavni.grigoryan on 10/2/2018.
 */
let CommonSettingsModule = class CommonSettingsModule {
};
CommonSettingsModule = __decorate([
    core_1.NgModule({
        declarations: [
            sis_reporting_chip_group_component_1.SisReportingChipGroupComponent
        ],
        exports: [
            sis_reporting_chip_group_component_1.SisReportingChipGroupComponent
        ],
        imports: [
            common_1.CommonModule,
            idm_ng_controls_1.ControlsModule,
            forms_1.FormsModule,
            material_module_1.MaterialModule,
            reporting_controls_module_1.ReportingControlsModule,
            forms_1.ReactiveFormsModule,
            reporting_filter_module_1.ReportingFilterModule,
            idm_currency_rate_frontend_1.SisCurrencyComboModule,
            ng2_dragula_1.DragulaModule,
        ],
        providers: [
            idm_dataset_service_client_js_1.HttpPathService,
            idm_reporting_service_client_js_1.HttpReportingService,
            color_palette_service_1.ColorPaletteService,
            idm_dataset_service_client_js_1.HttpDatasetService,
            idm_dataset_service_client_js_1.HttpPathFormsService,
            idm_frontend_shared_1.FormResolverService,
            { provide: idm_dataset_service_client_js_1.PathService, useExisting: idm_dataset_service_client_js_1.HttpPathService },
            { provide: idm_dataset_service_client_js_1.MeasurePathService, useClass: idm_dataset_service_client_js_1.HttpMeasurePathService },
            { provide: idm_dataset_service_client_js_1.ExpressionPathService, useClass: idm_dataset_service_client_js_1.HttpExpressionPathService },
            { provide: idm_dataset_service_client_js_1.CategoryPathService, useClass: idm_dataset_service_client_js_1.HttpCategoryPathService },
            { provide: idm_reporting_service_client_js_1.ReportingService, useExisting: idm_reporting_service_client_js_1.HttpReportingService },
            { provide: idm_report_export_service_client_js_1.ReportExportService, useClass: idm_report_export_service_client_js_1.HttpReportExportService },
            { provide: idm_export_client_js_1.ExportService, useClass: idm_export_client_js_1.HttpExportService },
            { provide: idm_dataset_service_client_js_1.DatasetService, useExisting: idm_dataset_service_client_js_1.HttpDatasetService },
            { provide: idm_dataset_service_client_js_1.PathFormsService, useExisting: idm_dataset_service_client_js_1.HttpPathFormsService },
            { provide: idm_page_service_client_js_1.PageNavigationService, useClass: idm_page_service_client_js_1.HttpPageNavigationService }
        ]
    })
], CommonSettingsModule);
exports.CommonSettingsModule = CommonSettingsModule;
//# sourceMappingURL=common-settings.module.js.map